export enum CancellationSource {
  Approval = "APPROVAL",
  Cancellation = "CANCELLATION",
  Refund = "REFUND",
}
